import { createApp, computed } from 'vue'
import { createPinia } from 'pinia'
import { useMaterialReportStore } from '@/src/stores/materialReport.store'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'
import MaterialReportSearch from '@/src/javascripts/material_reports/MaterialReportSearch.vue'

$(document).on('turbo:load turbo:render', () => {
  const materialReportIndex = document.querySelector('#material-report-index')
  if (materialReportIndex && !materialReportIndex.__vue_app__) {
    const pinia = createPinia()
    const app = createApp({
      components: { BaseAlert, MaterialReportSearch },
      setup () {
        const materialReportStore = useMaterialReportStore()
        const showtip = computed(() => materialReportStore.showtip)
        return {
          showtip
        }
      }
    })

    app.use(pinia)
    app.mount(materialReportIndex)
  }
})
